import { render, staticRenderFns } from "./GlobalSearchResults.vue?vue&type=template&id=60c25fb0&scoped=true"
import script from "./GlobalSearchResults.vue?vue&type=script&lang=js"
export * from "./GlobalSearchResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c25fb0",
  null
  
)

export default component.exports